import { allFromSnapshot, oneFromSnapshot, } from "@buildwithflux/firestore-compatibility-layer";
import { silentLogger } from "@buildwithflux/shared";
import { StorageSubscriptionManager } from "../subscriptions";
export class FirestoreUserJobRepository {
    db;
    logger;
    parsers;
    subscriptionMgr = new StorageSubscriptionManager();
    firestoreSubscriptions = new Map();
    constructor(db, logger = silentLogger, parsers) {
        this.db = db;
        this.logger = logger;
        this.parsers = parsers;
    }
    async get(userHandle, type, jobUid) {
        const raw = oneFromSnapshot(await this.db.userJobsCollection(userHandle).doc(jobUid).get(), () => undefined);
        if (!raw)
            return undefined;
        return this.parsers[type](raw);
    }
    async getByWorkflowId(userHandle, workflowId, jobType) {
        const raw = allFromSnapshot(await this.db.userJobsCollection(userHandle).where("workflowId", "==", workflowId).get());
        if (!raw)
            return undefined;
        // Relationship betwee job and workflow is 1:1
        return this.parsers[jobType](raw[0]);
    }
    subscribeToJob(user, jobType, jobUid, onChange) {
        const jobRef = this.db.userJobsCollection(user.handle).doc(jobUid);
        // Here's the other half - we're erasing the type inside the subscription and then reviving it when we fire the callback.
        const unsubscribe = this.subscriptionMgr.addSubscription(jobUid, onChange, () => {
            const existingSubCount = this.subscriptionMgr.listenerCount(jobUid);
            if (existingSubCount === 0) {
                const firestoreUnsub = this.firestoreSubscriptions.get(jobUid);
                if (firestoreUnsub) {
                    firestoreUnsub();
                    this.firestoreSubscriptions.delete(jobUid);
                }
            }
        });
        const existing = this.firestoreSubscriptions.get(jobUid);
        if (!existing) {
            const firestoreUnsub = jobRef.onSnapshot((snapshot) => {
                const data = snapshot.data();
                if (!data) {
                    this.logger.warn(`Job ${jobUid} does not exist in Firestore!`);
                    return;
                }
                this.notifyJobChangeListeners(jobUid, { type: "updated", data });
            });
            this.firestoreSubscriptions.set(jobUid, firestoreUnsub);
        }
        return unsubscribe;
    }
    notifyJobChangeListeners(jobUid, change) {
        this.subscriptionMgr.notify(jobUid, change);
    }
}
//# sourceMappingURL=FirestoreUserJobRepository.js.map